import {
  BarChart3,
  BookOpen,
  ClipboardCheck,
  FileText,
  HelpCircle,
  LayoutDashboard,
  MessageSquare,
  Package,
  Plus,
  ShoppingCart,
  TrendingUp,
  Boxes,
  TestTube,
  Shield,
  Home,
  MoreHorizontal,
  DollarSign,
  CalendarDays,
  Users,
} from "lucide-react";
import type { NavConfig } from "@/types/navigation";

export const supplierNavConfig: NavConfig = {
  primaryCTA: {
    label: "Add Product",
    mobileLabel: "Product",
    href: "/supplier/products?action=add",
    icon: Plus,
  },
  sections: [
    {
      id: "workspace",
      label: null,
      items: [
        { label: "Dashboard", href: "/supplier/dashboard", icon: LayoutDashboard },
        { label: "Production Board", href: "/supplier/operations", icon: ClipboardCheck },
        { label: "Production Scheduling", href: "/supplier/production-scheduling", icon: CalendarDays },
      ],
    },
    {
      id: "sales",
      label: "Sales Pipeline",
        icon: TrendingUp,
      items: [
        {
          label: "RFQ Marketplace",
          href: "/supplier/rfq-marketplace",
          icon: TrendingUp,
          badge: { metric: "activeRFQsMarketplace" },
        },
        {
          label: "Quotes",
          href: "/supplier/quotes",
          icon: FileText,
          badge: { metric: "pendingQuotes" },
        },
        {
          label: "Orders",
          href: "/supplier/orders",
          icon: ShoppingCart,
          badge: { metric: "pendingOrders", variant: "warning" },
        },
        {
          label: "Earnings",
          href: "/supplier/earnings",
          icon: DollarSign,
        },
        {
          label: "Messages",
          href: "/supplier/messages",
          icon: MessageSquare,
          badge: { metric: "unreadMessages" },
        },
        { label: "Analytics", href: "/supplier/analytics", icon: BarChart3 },
        { label: "Win/Loss Analytics", href: "/supplier/analytics/win-loss", icon: TrendingUp },
        { label: "Team Analytics", href: "/supplier/team-analytics", icon: Users },
      ],
    },
    {
      id: "crm",
      label: "CRM",
      icon: Users,
      items: [
        { label: "Customers", href: "/supplier/customers", icon: Users },
        { label: "Leads", href: "/supplier/customers?type=prospect", icon: Users },
      ],
    },
    {
      id: "production",
      label: "Production & Catalog",
        icon: Package,
      items: [
        { label: "Products", href: "/supplier/products", icon: Package },
        { label: "Inventory", href: "/supplier/inventory", icon: Boxes },
        { label: "Sample Requests", href: "/supplier/sample-requests", icon: TestTube },
        { label: "Sample Analytics & Reports", href: "/supplier/sample-requests-analytics-reports", icon: BarChart3 },
      ],
    },
    {
      id: "compliance",
      label: "Compliance & Support",
        icon: Shield,
      items: [
        { label: "Compliance Portal", href: "/supplier/compliance", icon: Shield },
        { label: "Resources", href: "/supplier/resources", icon: BookOpen },
        { label: "Support", href: "/supplier/support", icon: HelpCircle },
      ],
    },
  ],
  mobileBottomNav: [
    { label: "Dashboard", href: "/supplier/dashboard", icon: Home },
    {
      label: "RFQs",
      href: "/supplier/rfq-marketplace",
      icon: TrendingUp,
      badge: { metric: "activeRFQsMarketplace" },
    },
    {
      label: "Orders",
      href: "/supplier/orders",
      icon: ShoppingCart,
      badge: { metric: "pendingOrders", variant: "warning" },
    },
    {
      label: "Messages",
      href: "/supplier/messages",
      icon: MessageSquare,
      badge: { metric: "unreadMessages" },
    },
    {
      label: "More",
      href: "#more",
      icon: MoreHorizontal,
      type: "more",
    },
  ],
};
